import { useCallback, useState } from "react";

import { SEAL_VALIDATION_URL, SUBMISSION_DISABLED } from "../constants";

let sealPromise: Promise<unknown[]> | null = null;
const getSealOnce = (): Promise<unknown[]> => {
  if (sealPromise) return sealPromise;
  sealPromise = fetch(SEAL_VALIDATION_URL, {
    method: "GET",
    redirect: "follow",
  })
    .then((r) => r.json())
    .catch(() => [] as unknown[]);
  return sealPromise;
};

export const useSealValidation = () => {
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");

  const validateSeal = useCallback(async () => {
    if (SUBMISSION_DISABLED) return [];
    setStatus("loading");
    try {
      const seal = await getSealOnce();
      setStatus("success");
      return seal;
    } catch (error) {
      setStatus("error");
    }
    return [];
  }, []);
  return { validateSeal, status };
};
